<template>
  <div
    v-if="leagueType === 0 || (leagueType === 1 && prizes.first)"
    class="d-flex align-items-center flex-fill"
  >
    <font-awesome-icon
      :icon="['far', 'gem']"
      size="2x"
    />
    <div class="pl-2">
      <span :class="$style.smallText">{{ text }}</span>
      <div class="d-flex align-items-center">
        <span
          :class="$style.jackpot"
          class="pr-2"
        >
          <template v-if="leagueType === 1">
            {{ prizes.first.prize }}{{ currency }}
          </template>
          <template v-else>
            {{ jackpot }}{{ currency }}
          </template>
        </span>
        <font-awesome-icon
          :class="$style.jackpotInfoIcon"
          icon="info-circle"
          size="lg"
          @click="handleOpenRoundJackpotModal"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'RoundJackpot',
  props: {
    text: {
      type: String,
      required: true,
      default: '',
    },
    jackpot: {
      type: [String, Number],
      required: false,
      default: 0,
    },
    prizes: {
      type: [Object],
      required: false,
      default: () => ({
        first: null,
        second: null,
      }),
    },
    guaranteedJackpot: {
      type: Boolean,
      required: false,
      default: false,
    },
    roundId: {
      type: Number,
      required: false,
      default: null,
    },
    leagueType: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  computed: {
    currency() {
      return process.env.VUE_APP_CURRENCY_SYMBOL
    },
  },
  methods: {
    ...mapActions({
      openRoundJackpotOverviewModal: 'rounds/roundJackpotOverview/openRoundJackpotOverviewModal',
    }),
    handleOpenRoundJackpotModal() {
      const defaultParams = {
        roundId: this.roundId,
        leagueType: this.leagueType,
      }
      let params = {}
      if (this.leagueType === 1) {
        params = { ...defaultParams, prizes: this.prizes }
      } else {
        params = !this.guaranteedJackpot
          ? { ...defaultParams, jackpot: this.jackpot }
          : { ...defaultParams, guaranteedJackpot: this.jackpot }
      }
      this.openRoundJackpotOverviewModal(params)
    },
  },
}
</script>

<style module lang="scss">
  @import '../../../../assets/scss/variables';
  .smallText {
    font-size: $font-size-small;
  }
  .orangeText {
    color: $color-tomato !important;
  }
  .jackpot {
    color: $color-tomato;
    font-size: $font-size-xxlarge;
    font-weight: 600;
    line-height: 30px;
  }
  .jackpotInfoIcon {
    cursor: pointer;
  }
</style>
